import React, { createContext, ReactNode, useCallback, useContext, useState } from "react";
import { ErrorDialog } from "./ErrorDialog";

interface ErrorDialogContextType {
  showError: () => void;
  hideError: () => void;
  isErrorVisible: boolean;
}

const ErrorDialogContext = createContext<ErrorDialogContextType | undefined>(undefined);

type ErrorDialogProviderProps = {
  children: ReactNode;
};

export const ErrorDialogProvider: React.FC<ErrorDialogProviderProps> = ({ children }) => {
  const [isErrorVisible, setIsErrorVisible] = useState(false);

  const showError = useCallback(() => {
    setIsErrorVisible(true);
  }, []);

  const hideError = useCallback(() => {
    setIsErrorVisible(false);
  }, []);

  return (
    <ErrorDialogContext.Provider value={{ showError, hideError, isErrorVisible }}>
      {children}
      <ErrorDialog isOpen={isErrorVisible} onClose={hideError} />
    </ErrorDialogContext.Provider>
  );
};

export const useErrorDialog = (): ErrorDialogContextType => {
  const context = useContext(ErrorDialogContext);
  if (context === undefined) {
    throw new Error("useErrorDialog must be used within an ErrorDialogProvider");
  }
  return context;
};
